// Setup Vue
import { createApp } from 'vue'
window.Vue = createApp;
window.$ = window.jQuery = jQuery;

// Our extensions and components
import modalDynamic from './components/modal-dynamic.vue';

var app = createApp({
    components: {
        'modal-dynamic': modalDynamic,
    },

    // mixins: [TimecardMixin, UtilitiesMixin, COAMixin, DateFormatUtil],

    data() {
        return {
            adminAccess: false,
            modals: [],  // Dynamic modals
            openModals: 0,  // Dynamic modals counting
            buttonYesAction: [],
            buttonNoAction: [],
            button3Action: [],
        }
    },

    computed: {
        width() {
            // Reducing by 3 % to handle sigma-frontend navbar
            return '100%';
        },

        height() {
            // Reducing by 3 % to handle sigma-frontend navbar
            return window.innerHeight * 0.32 + 'px';
        },
    },

    methods: {
        // Archive a project
        updateProject(entityId=null, archive=true) {
            if (!entityId) {
                this.createDialog({
                    "title": "Error",
                    "body": 'No project selected.',
                    "buttonNo": false,
                    "buttonYesLabel": 'OK'
                });
            } else {
                const body = archive ? 'Archiving this project will prevent any new timecards or starts from being created or submitted.  Only users with appropriate permissions can complete this action.' : 'If you have the appropriate permissions, this project will be unarchived.';
                const buttonYes = archive ? 'Archive' : 'Unarchive';
                const action = archive ? 1 : 0;
                this.createDialog({
                    "title": "Mark as Archived?",
                    "body": body,
                    "buttonNo": true, "buttonNoLabel": "Cancel",
                    "buttonYesLabel": buttonYes, "buttonYesAction": function () { window.location.href = `/oasis/welcome/maintenance/${entityId}/${action}`; }
                });
            }
        },

        // Generic test function
        log(value) {
            console.log('Logging:');
            console.log(value);
        },

        // Create a dynamic modal dialog box with buttons and labels
        createDialog(options) {
            let index = this.openModals;
            options.id = index;

            if (options.buttonYesAction) { this.buttonYesAction[index] = options.buttonYesAction;
            } else { this.buttonYesAction[index] = function () {}; }

            if (options.buttonYesLabel) { this.buttonYesLabel = options.buttonYesLabel;
            } else { options.buttonYesLabel = 'Yes'; }

            if (options.buttonNoAction) { this.buttonNoAction[index] = options.buttonNoAction;
            } else { this.buttonNoAction[index] = function () {}; }

            if (options.buttonNoLabel) { this.buttonNoLabel = options.buttonNoLabel;
            } else { options.buttonNoLabel = 'No'; }

            if (options.button3Action) { this.button3Action[index] = options.button3Action;
            } else { this.button3Action[index] = function () {}; }

            if (options.button3Label) { this.button3Label = options.button3Label;
            } else { options.button3Label = 'Maybe'; }

            this.modals.push(options);
            this.openModals++;
        },

        // Close the dynamic modal
        closeModal(index) {
            this.modals.splice(index, 1);
            this.buttonYesAction.splice(index, 1);
            this.buttonNoAction.splice(index, 1);
            this.button3Action.splice(index, 1);
            this.openModals--;
        },

        modalConfirm(index) {
            this.buttonYesAction[index]();
        },

        modalCancel(index) {
            this.buttonNoAction[index]();
        },

        modalButton3(index) {
            this.button3Action[index]();
        },

        createLink(value) {
            return value;
        },
    },

    watch: {
    },

    async created() {
    },

    beforeCreate() {
        // this.oasisApi = new Axios('/restv2');
    },

    async mounted() {
        setTimeout(function () { $(function () { $('[data-toggle="tooltip"]').tooltip() }) }, 500);
        // Prevent back button from failing.
        history.pushState(null, document.referrer, location.href);
        window.onpopstate = function () {
            window.location.href = document.referrer;
        };
        this.adminAccess = typeof adminAccess !== 'undefined' ? (adminAccess ? true : false) : false;
    }
}).mount("#main");

